import { CommonModule, DOCUMENT, isPlatformBrowser, NgOptimizedImage } from '@angular/common'
import { afterNextRender, Component, DestroyRef, ElementRef, HostListener, Inject, inject, Input, OnInit, PLATFORM_ID, signal, ViewChild, ViewEncapsulation } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatButtonToggleModule } from '@angular/material/button-toggle'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatInputModule } from '@angular/material/input'
import { MatTabsModule } from '@angular/material/tabs'
import { MatIconModule } from '@angular/material/icon'
import { HotelRepository } from '@core/services/repositories/hotel.repository'
import { SwiperService } from '@shared/services/swiper-config.service'
import { SwiperModule } from 'swiper/angular'
import { cdnUrl } from '../../../app.module'


@Component({
  selector: 'iho-popular-destination',
  templateUrl: './popular-destination.component.html',
  styleUrls: ['./popular-destination.component.scss'],
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  providers: [],
  imports: [
    MatInputModule,
    MatTabsModule,
    MatFormFieldModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatIconModule,
    CommonModule,
    SwiperModule,
    NgOptimizedImage,
  ]
})

export class PopularDestinationComponent implements OnInit {
  @Input() data: any;
  @ViewChild('mobileContainer') mobileContainer!: ElementRef;
  
  configSwiper: any;
  configSwiperMobile: any;
  resetSwiper = signal(true);
  isExpanded = signal(false);
  isSticky = signal(false);
  cdnUrl = cdnUrl;
  
  private initialOffsetTop = 0;
  private isBrowser = false;
  private activeCityIndex: number | null = null;
  private isScrolling = false;

  constructor(
    private swiperService: SwiperService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
    afterNextRender(() => {
      this.resetSwiper.set(false);
      setTimeout(() => {
        this.resetSwiper.set(true);
        setTimeout(() => {
          if (this.mobileContainer?.nativeElement) {
            this.initialOffsetTop = this.mobileContainer.nativeElement.getBoundingClientRect().top + window.scrollY;
          }
        }, 100);
      }, 0);
    });
  }
  
  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    if (!this.isBrowser) return;
    
    const scrollPosition = window.scrollY;
    const windowWidth = window.innerWidth;
    
    if (windowWidth < 768) {
      if (scrollPosition > this.initialOffsetTop && !this.isSticky()) {
        this.isSticky.set(true);
        this.resetSwiper.set(false);
        setTimeout(() => this.resetSwiper.set(true), 0);
      } else if (scrollPosition <= this.initialOffsetTop && this.isSticky()) {
        this.isSticky.set(false);
      }
    } else {
      if (this.isSticky()) {
        this.isSticky.set(false);
      }
    }
  }
  
  ngOnInit(): void {
    const config = {
      slide: "auto",
      pagination: {
        enabled: false,
        clickable: false,
      },
      navigation: {
        prevEl : '.swiper-button-next-popular',
        nextEl: '.swiper-button-prev-popular',
      },
      autoplay: {
        delay: 5000,
      },
    };
    this.configSwiper = this.swiperService.SwiperConfig(config);
    
    this.configSwiperMobile = {
      slidesPerView: 'auto',
      spaceBetween: 4,
      grabCursor: true,
      freeMode: true,
    };
  }

  toggleExpand(): void {
    this.isExpanded.set(!this.isExpanded());
  }

  scrollToCity(itemHotel: any, index: number, event?: Event): void {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
  
    if (!this.isBrowser) return;
  
    const cityId = 'city-' + index;
    const element = document.getElementById(cityId);
  
    if (!element) return;
  
    const windowWidth = window.innerWidth;
    const offset = windowWidth < 768 ? 420 : 40;
  
    const rect = element.getBoundingClientRect();
    const elementPositionFromTop = rect.top + window.scrollY;
    
    const targetPosition = Math.max(0, elementPositionFromTop - offset);
    
    const currentElementTopFromViewport = rect.top;
    const distanceFromTop = Math.abs(currentElementTopFromViewport - offset);
    
    const currentScrollPosition = window.scrollY;
    const scrollDifference = Math.abs(currentScrollPosition - targetPosition);
  
    if (this.activeCityIndex === index && distanceFromTop <= 20 && scrollDifference <= 20 && !this.isScrolling) {
      return;
    }
  
    this.isScrolling = true;
    this.activeCityIndex = index;
  
    window.scrollTo({
      top: targetPosition,
      behavior: 'smooth'
    });
  
    const checkScrollEnd = () => {
      const currentPos = window.scrollY;
      const diff = Math.abs(currentPos - targetPosition);
      
      if (diff <= 5) {
        this.isScrolling = false;
      } else {
        requestAnimationFrame(checkScrollEnd);
      }
    };
    
    setTimeout(() => {
      requestAnimationFrame(checkScrollEnd);
    }, 100);
  }
  
}
